<nav class="bg-primary-900">
  <div class="app__container">
    <div class="relative flex h-16 items-center justify-between text-white">
      <div>
        <div class="text-white">Emitir Cotización #{{ quote()?.internalNumber ?? '' }}</div>
      </div>
      <div class="flex ">


        <activar-button text="Cancelar" fill="solid" color="danger" (click)="openModal()" />
      </div>
    </div>
    
  </div>
</nav>

<ng-container *showForRole="['ADMIN']">
  <app-producer-selector-modal (userSelected)="setAgent($event)"/>
</ng-container>

<div class="app__container pb-20">
  <router-outlet />
</div>

<activar-modal [(visible)]="isLeavingModalVisible">
  <div class="flex-col mx-auto p-5 text-center" style="width: 400px">
    <h2>Estas por cerrar la emisión</h2>
    <p>Se perderan todos los datos del proceso de emisión.</p>

    <div class="flex mt-7 items-center justify-center gap-5">
      <activar-button
        text="Cancelar"
        fill="out"
        expand="full"
        color="primary"
        (click)="closeModal()"
      />
      <activar-button
        text="Cerrar emisión"
        fill="solid"
        expand="full"
        color="danger"
        (click)="closeQuoter()"
      />
    </div>
  </div>
</activar-modal>

<activar-modal [(visible)]="isOptionalCoverageModalVisible">
  <div class="flex-col mx-auto p-5 text-center" style="width: 400px">
    <h2 class="text-md">Cubrí el vehículo mientras se encuentra guardado</h2>
    <p class="text-base mb-5">
      Agregá una cobertura de robo e incendio en garage para obtener una
      cobertura completa del vehículo.
    </p>
    @if(isOptionalCoverageModalVisible && getCoverage()){
    <app-quoter-sidebar-coverage [coverage]="getCoverage()!" [currency]="quote()?.currency ?? 'ARS'"/>
    } @else if(isOptionalCoverageModalVisible) {
      <p class="text-sm text-gray-500">Cargando datos de cobertura...</p>
    }

    <div class="flex mt-7 items-center justify-center gap-5">
      <activar-button
        text="No la necesito"
        fill="out"
        expand="full"
        color="primary"
        (click)="closeOptionalCoverageModal()"
      />
      <activar-button
        text="Agregar"
        fill="solid"
        expand="full"
        color="primary"
        (click)="addOptionalCoverage()"
      />
    </div>
  </div>
</activar-modal>